/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const otherContractTranslations = {
  label: "Sonstiger Vertrag",
  ...abstractContractClaimTranslations,
};

export default otherContractTranslations;
